import Vue from "vue";
import VueI18n from "vue-i18n";
import getLocale from "@/utils/locale";
import Header from "@/features/header/components/header-content";
import store from "@/store/";

const initHeader = () => {
  const el = document.getElementById("header-content");

  if (!el) {
    return;
  }

  const config = JSON.parse(el.dataset.config || "{}");

  Vue.use(VueI18n);

  new Vue({
    name: "HeaderContent",
    el,
    store,
    components: { Header },
    i18n: new VueI18n({ locale: getLocale() }),
    render (createElement) {
      return createElement(Header, {
        props: {
          hasLoginLink: config.hasLoginLink,
          hasSignupLink: config.hasSignupLink,
          hasPricingLink: config.hasPricingLink,
          hasUserMenu: config.hasUserMenu,
          hasLibraryLink: config.hasLibraryLink,
          hasHighlightsLink: config.hasHighlightsLink,
          hasDiscoverMenu: config.hasDiscoverMenu,
          hasSearch: config.hasSearch,
          hasUpgradeLink: config.hasUpgradeLink,
          hasBusinessLink: config.hasBusinessLink,
          cta: config.cta
        }
      });
    }
  });
};

export default initHeader;
